import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-placement-detail',
  templateUrl: './placement-detail.component.html',
  styleUrls: ['./placement-detail.component.css']
})
export class PlacementDetailComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<PlacementDetailComponent>
  ) { }
  onNoClick(): void {
    this.dialog.close();
  }
}
